import React from "react";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";

const StatusList = (props:any) => {

  const {handleIsActive, handleIsRTV,handleIsFinalState} = props
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Color",
      accessorKey: "color",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={`h-4 w-16`} style={{background: getValue()}}>
          </div>
        )
      },
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />
      ),
    },
    {
      header: "Allow RTV Order",
      accessorKey: "is_allow_to_create_rtv",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />
      )
    },
    {
      header: "Is Final State",
      accessorKey: "is_final_state",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />
      )
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.STATUS}
      queryKey={"status"}
      columns={defaultColumns}
      addNewPagePath={null}
      tableName={"Status"}
    />
  );
};

export default StatusList;
